import React from "react";

const NAV_LINKS = [
  { label: "Services", id: "services" },
  { label: "Work",     id: "projects" },
  { label: "About",    id: "about"    },
  { label: "Contact",  id: "contact"  },
];

const Footer = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0F172A] border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8 mb-10">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-2">
              <div className="h-8 w-8 bg-[#2D6A60] flex items-center justify-center rounded-sm">
                <span className="text-white font-bold text-[12px]">NB</span>
              </div>
              <span className="text-white font-bold text-[15px]">Noman Basit</span>
            </div>
            <p className="text-[13px] text-white/40 max-w-[220px] leading-relaxed">
              Full-stack web development & consulting for businesses that want to grow.
            </p>
          </div>

          {/* Nav */}
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {NAV_LINKS.map(({ label, id }) => (
              <button
                key={id}
                onClick={() => scrollTo(id)}
                className="text-[13px] text-white/50 hover:text-white transition-colors duration-150 font-medium"
              >
                {label}
              </button>
            ))}
          </nav>

          {/* Social */}
          <div className="flex items-center gap-2">
            <a
              href="https://www.linkedin.com/in/noman-basit/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="h-9 w-9 bg-white/10 hover:bg-[#2D6A60] border border-white/10 rounded-sm flex items-center justify-center transition-colors duration-200"
            >
              <svg className="h-4 w-4 text-white" fill="currentColor" viewBox="0 0 448 512">
                <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/>
              </svg>
            </a>
            <a
              href="https://github.com/FishySenpai"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
              className="h-9 w-9 bg-white/10 hover:bg-[#2D6A60] border border-white/10 rounded-sm flex items-center justify-center transition-colors duration-200"
            >
              <svg className="h-4 w-4 text-white" fill="currentColor" viewBox="0 0 496 512">
                <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[12px] text-white/30">
            &copy; {new Date().getFullYear()} Noman Basit. All rights reserved.
          </p>
          <p className="text-[12px] text-white/30">
            Built with React & TailwindCSS
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
